import axios from '../plugins/axios'
import type { AxiosResponse } from 'axios'
import type { IServerResponse } from '@/models/IServerResponse'
import type { ISuicleanDashboard } from '@/models/ISuicleanDashboard'

const resource = 'api/v1/domicile'

export default {
    getSuicleanDashboard(domicileId, params = ''): Promise<AxiosResponse<IServerResponse<ISuicleanDashboard>>> {
        return axios.get(`${resource}/client/${domicileId}/suiclean/dashboard${params ? `?${params}` : ''}`)
    },

    postUpdateDomicile(domicileId, mapsData): Promise<AxiosResponse<IServerResponse<void>>> {
        return axios.post(`${resource}/update/${domicileId}`, mapsData)
    },
}
